import { randomInt } from "crypto";
import { groupBy } from "lodash";
import templateData from "./templateData.json";

export type Category = {
  id: string;
  title: string;
};

export const CATEGORY: Category[] = [
  { id: "chill", title: "Chill together" },
  { id: "work", title: "Work together" },
  { id: "browse", title: "Browse together" },
  { id: "play", title: "Play together" },
];

const CID = CATEGORY.map((c) => c.id);

export type Template = {
  name: string;
  spaceId: string;
  category?: Category;
  screenshot?: string;
};

for (const x of templateData) {
  const valid =
    CID.includes(x.category) &&
    typeof x.name === "string" &&
    typeof x.spaceId === "string";

  if (!valid) {
    throw new Error("internal erro: invalid template data");
  }
}

export const GALLERY_TEMPLATES = groupBy(
  templateData as unknown as Template[],
  "category"
);

export const FEATURE_TEMPLATES: Template[] = [
  "e29249e92b4e4109b5f71cc164ef5ea0",
  "e688d8521e904775812c3aa1977a3c03",
  "fd29d71160fb463e96221231989ac1f0",
].map((spaceId) => {
  const t = templateData.find((x) => x.spaceId === spaceId);
  if (!t) throw new Error("internal error: template not found");

  return t as unknown as Template;
});

export function pickTemplate(cid: Category["id"]): Template | null {
  const list = GALLERY_TEMPLATES[cid];
  if (!list) return null;

  return list[randomInt(0, list.length)];
}
